import React, { useState, useEffect, useRef } from "react";
import { GoPrimitiveDot } from "react-icons/go";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logo1 from "../img/partner/logo/1.svg";
import logo2 from "../img/partner/logo/2.svg";
import logo3 from "../img/partner/logo/3.svg";
import logo4 from "../img/partner/logo/4.svg";
import logo5 from "../img/partner/logo/5.svg";
import logo6 from "../img/partner/logo/6.svg";
import logo7 from "../img/partner/logo/7.svg";
import logo8 from "../img/partner/logo/8.svg";
import logo9 from "../img/partner/logo/9.svg";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 10000,
};

const settings_2 = {
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,
};
const Section_6 = () => {
  const [togglePagination, setTogglePagination] = useState([true, false]);
  const [index, setIndex] = useState(0);

  useEffect(() => {}, [index, togglePagination]);

  const paginationDots = [
    {
      logo: "Simple Solutions",
      des: "“The process of obtaining the BOI certification was not easy and presented many challenges. The Accept team’s expertise and dedication to the task meant a huge amount to us.”",
      company_name: "Simple Solutions",
      company_factory: "Simple manufacturing",
      img: "https://thailand.acclime.com/wp-content/themes/yootheme/cache/d6/wooden-house-d68eb8c4.webp",
    },
    {
      logo: "Casual Limited",
      des: "“Presented with the issues in our case, they were able to understand our position and provided options with respect to finding solution. Accept were knowledgeable in their field of work.”",
      company_name: "Casual Limited",
      company_factory: "Entertainment",
      img: "https://thailand.acclime.com/wp-content/themes/yootheme/cache/54/events-544321e8.webp",
    },
  ];
  const handlePagination = (i) => {
    if (i === 0) {
      if (!togglePagination[0]) {
        setTogglePagination([true, false]);

        setIndex(0);
        console.log("i=0");
      }
    } else if (i === 1) {
      if (!togglePagination[1]) {
        setTogglePagination([false, true]);
        // setTogglePagination[1] = true
        setIndex(1);
        console.log(togglePagination);
        console.log("i=1");
      }
    }
  };
  return (
    <div className="js-show-on-scroll bg-[#f7f7f7] xl:px-[8rem] w-[100vw] xl:mt-20 xl:py-20 p-5">
      <p className=" xl:text-center text-[#00263e]">Client stories</p>
      <h1 className=" xl:text-center text-[36px] text-[#00263e] font-bold xl:px-64 ">
        Trusted by regional groups, foreign SMEs and entrepreneurs.
      </h1>
      {/* <div className='grid grid-cols-2 xl:gap-6 rounded-xl shadow-lg bg-white xl:mt-10'>
                <div className='px-16 py-20 text-[#00263e]'>
                    <h1 className=' text-3xl underline-orange font-bold uppercase'>{paginationDots[index].logo}</h1>
                    <p className=' text-[20px] mt-3'>{paginationDots[index].des}</p>
                    <h1 className=' text-[24px] mt-3 font-bold uppercase'>{paginationDots[index].company_name}</h1>
                    <p className=' text-[14px] text-gray-500 '>{paginationDots[index].company_factory}</p>
                    <p className=' text-[16px] mt-3 ' href="#">
                        <span className=' border-b-2 border-[#00263e] cursor-pointer'>Read their story</span>
                    </p>
                </div>
                <div className=' w-full'>
                    <img className=' w-full rounded-r-xl' src={paginationDots[index].img} alt={paginationDots[index].company_name} />
                </div>
            </div>
            <div className='flex justify-center items-center mt-3'>

                <GoPrimitiveDot className={` cursor-pointer ${togglePagination[0] ? " text-orange-500" : " text-gray-500 hover:text-orange-500"}  `} size={22} onClick={() => handlePagination(0)} />
                <GoPrimitiveDot className={` cursor-pointer ${togglePagination[1] ? " text-orange-500" : " text-gray-500 hover:text-orange-500"}  `} size={22} onClick={() => handlePagination(1)} />



            </div> */}
      <div className=" xl:m-0 mt-3">
        <Slider {...settings}>
          <div>
            <div className="grid xl:grid-cols-2 xl:gap-6 rounded-xl shadow-lg bg-white xl:mt-10">
              <div className="xl:px-16 xl:py-20 p-5 text-[#00263e]">
                <h1 className=" text-3xl underline-orange font-bold uppercase">
                  {paginationDots[0].logo}
                </h1>
                <p className=" text-[20px] mt-3">{paginationDots[0].des}</p>
                <h1 className=" text-[24px] mt-3 font-bold uppercase">
                  {paginationDots[0].company_name}
                </h1>
                <p className=" text-[14px] text-gray-500 ">
                  {paginationDots[0].company_factory}
                </p>
                <p className=" text-[16px] mt-3 " href="#">
                  <span className=" border-b-2 border-[#00263e] cursor-pointer">
                    Read their story
                  </span>
                </p>
              </div>
              <div className=" w-full xl:row-start-auto row-start-1">
                <img
                  className=" w-full xl:rounded-r-xl rounded-t-xl"
                  src={paginationDots[0].img}
                  alt={paginationDots[0].company_name}
                />
              </div>
            </div>
          </div>
          <div>
            <div className="grid xl:grid-cols-2 xl:gap-6 rounded-xl shadow-lg bg-white xl:mt-10">
              <div className="xl:px-16 xl:py-20 p-5 text-[#00263e]">
                <h1 className=" text-3xl underline-orange font-bold uppercase">
                  {paginationDots[1].logo}
                </h1>
                <p className=" text-[20px] mt-3">{paginationDots[1].des}</p>
                <h1 className=" text-[24px] mt-3 font-bold uppercase">
                  {paginationDots[1].company_name}
                </h1>
                <p className=" text-[14px] text-gray-500 ">
                  {paginationDots[1].company_factory}
                </p>
                <p className=" text-[16px] mt-3 " href="#">
                  <span className=" border-b-2 border-[#00263e] cursor-pointer">
                    Read their story
                  </span>
                </p>
              </div>
              <div className=" w-full xl:row-start-auto row-start-1">
                <img
                  className=" w-full xl:rounded-r-xl rounded-t-xl"
                  src={paginationDots[1].img}
                  alt={paginationDots[1].company_name}
                />
              </div>
            </div>
          </div>
        </Slider>
      </div>
      <div className=" w-full xl:mt-20 mt-10">
        <Slider {...settings_2} className=" xl:pl-12 opacity-40">
          <div className="">
            <img className="w-[150px]" src={logo1} alt="" />
          </div>
          <div>
            <img className="w-[150px]" src={logo2} alt="" />
          </div>
          <div>
            <img className="w-[150px]" src={logo3} alt="" />
          </div>
          <div>
            <img className="w-[150px]" src={logo4} alt="" />
          </div>
          <div>
            <img className="w-[150px]" src={logo5} alt="" />
          </div>
          <div>
            <img className="w-[150px]" src={logo6} alt="" />
          </div>

          <div>
            <img className="w-[150px]" src={logo7} alt="" />
          </div>
          <div>
            <img className="w-[150px]" src={logo8} alt="" />
          </div>
          <div>
            <img className="w-[150px]" src={logo9} alt="" />
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Section_6;
